import { ApiResponse } from "@axl-dev/school-sdk";
import { ReactNode } from "react";

import { useApiRequest } from "../lib/hooks";

type RequestProps<TData, TCb> = {
  action: TCb;
  children:
    | ((obj: {
        exec: TCb;
        loading: boolean;
        data: TData | null;
        state: "idle" | "loading" | "success" | "error";
      }) => React.ReactNode)
    | React.ReactNode;
  onSuccess?: (d: TData) => void;
  successMsg?: React.ReactNode;
  auto?: boolean;
  mock?: TData;
  // TODO
  // disableErrorNotify?: boolean;
};
const Request = function Req<TData>({
  action,
  successMsg,
  onSuccess,
  children,
  auto,
  mock,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}: RequestProps<TData, (params?: any) => Promise<ApiResponse<TData>>>) {
  const [exec, { loading, data, state }] = useApiRequest(action, {
    auto,
    mock,
    onSuccess,
    successMsg,
  });

  return (
    <>
      {(() => {
        if (typeof children !== "function") return children;

        return children({
          exec,
          loading,
          data,
          state,
        }) as ReactNode;
      })()}
    </>
  );
};

export default Request;
